import request from './request';

const sanitizeParams = (params = {}) => {
  const result = { ...params };
  if (Object.prototype.hasOwnProperty.call(result, 'search')) {
    const searchValue =
      result.search === undefined || result.search === null
        ? ''
        : String(result.search).trim();
    if (!searchValue) {
      delete result.search;
    } else {
      result.search = searchValue;
    }
  }
  return result;
};

const deliveryPriceService = {
  get: (params) =>
    request.get('dashboard/admin/delivery-prices', { params: sanitizeParams(params) }),
  getById: (id, params) =>
    request.get(`dashboard/admin/delivery-prices/${id}`, { params }),
  delete: (params) =>
    request.delete('dashboard/admin/delivery-prices/delete', { params }),
  create: (data) => request.post('dashboard/admin/delivery-prices', data),
  update: (id, data) =>
    request.put(`dashboard/admin/delivery-prices/${id}`, data),
};

export default deliveryPriceService;
